<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>输入框组件技能库</h2>
      <p>展示Element UI输入框组件的个性化用法和自定义样式</p>
    </div>

    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" :md="8" :lg="6">
        <CodeCard 
          title="自定义样式输入框" 
          description="深色背景、自定义边框和占位符颜色的输入框样式"
          :codeContent="inputCode">
          <CustomInput />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import CustomInput from './components/CustomInput.vue'

export default {
  name: 'PcInput',
  components: {
    CodeCard,
    CustomInput
  },
  data() {
    return {
      inputCode: `<template>
  <div class="input-wrapper">
    <el-input 
      @change="handleChange" 
      v-model="localValue" 
      placeholder="请输入" 
      clearable 
    />
    <div class="info-area">
      <div class="title">普通输入框(自定义样式)</div>
      <div class="current-value">
        <span class="label">绑定值:</span>
        <span class="value">{{ localValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localValue: ''
    }
  },
  methods: {
    handleChange() {
      console.log(this.localValue);
    }
  }
}
<\/script>

<style scoped lang="scss">
::v-deep .el-input__inner::placeholder {
  color: #fff;
}
::v-deep .el-input__inner{
  background-color: rgba(8, 35, 62, 0.9) !important;
  border: 1px solid rgb(83, 185, 232) !important;
  color: #fff !important;
}
<\/style>`
    }
  }
}
</script>

<style scoped>
/* 全局样式已由 global.scss 提供 */
</style>
